import RequestAbortSignal from '@/Enums/Attribution/FootTraffic/RequestAbortSignal.enum';
import ReportCard from '@/components/ReportCard';
import { useRequestSaver } from '@/hooks/RequestSaver';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectFootTrafficFilters } from '@/store/selectors/attribution/footTraffic.selectors';
import { selectHideClients, selectHideWhitelabels } from '@/store/selectors/me.selectors';
import { selectSharedApiLoading } from '@/store/selectors/sharedApi.selectors';
import {
  getFootTrafficImpressionsReports,
  getFootTrafficVisitsReports,
  resetFootTrafficPageState,
} from '@/store/slices/attribution/footTraffic.slice';
import { useEffect } from 'react';
import DwellTimeCard from './Components/Cards/DwellTimeCard';
import FootTrafficTotalsCard from './Components/Cards/FootTrafficTotalsCard';
import FootTrafficVisitsCard from './Components/Cards/FootTrafficVisitsCard';
import HourOfDayCard from './Components/Cards/HourOfDayCard';
import OnAirOffAirBar from './Components/Cards/OnAirOffAirBar';
import TradeAreaCard from './Components/Cards/TradeAreaCard';
import VisitFrequencyCard from './Components/Cards/VisitFrequencyCard';
import WeekdayCard from './Components/Cards/WeekdayCard';
import Filters from './Components/Filters/FootTraffic';
import InsightSummaryBox from './Components/InsightSummaryBox';

const FootTrafficTab = () => {
  const requestSaver = useRequestSaver();

  const dispatch = useAppDispatch();
  const filters = useAppSelector(selectFootTrafficFilters);

  const sharedApiLoading = useAppSelector(selectSharedApiLoading);
  const hideWhitelabels = useAppSelector(selectHideWhitelabels);
  const hideClients = useAppSelector(selectHideClients);

  useEffect(() => {
    if (!sharedApiLoading) {
      dispatch(
        getFootTrafficImpressionsReports(
          requestSaver.requestSaverSetCancellation(RequestAbortSignal.ImpressionsReports),
        ),
      );
      dispatch(
        getFootTrafficVisitsReports(requestSaver.requestSaverSetCancellation(RequestAbortSignal.ImpressionsReports)),
      );
    }
  }, [filters, sharedApiLoading, dispatch]);

  useEffect(() => {
    return () => {
      requestSaver.requestSaverAbortAll();
      dispatch(resetFootTrafficPageState());
    };
  }, [dispatch]);

  return (
    <div className='grid grid-cols-4 gap-[30px]'>
      <div className='col-span-4'>
        <Filters hideWhitelabels={hideWhitelabels} hideClients={hideClients} />
      </div>
      <InsightSummaryBox />
      <FootTrafficTotalsCard />
      <ReportCard className='col-span-4' printPageBreak>
        <FootTrafficVisitsCard />
      </ReportCard>
      <ReportCard className='col-span-4'>
        <OnAirOffAirBar />
      </ReportCard>
      <ReportCard className='col-span-4'>
        <WeekdayCard />
      </ReportCard>
      <ReportCard className='col-span-4' printPageBreak>
        <HourOfDayCard />
      </ReportCard>
      <ReportCard className='col-span-4'>
        <DwellTimeCard />
      </ReportCard>
      <ReportCard className='col-span-4' printPageBreak>
        <VisitFrequencyCard />
      </ReportCard>
      <ReportCard className='col-span-4'>
        <TradeAreaCard />
      </ReportCard>
    </div>
  );
};
export default FootTrafficTab;
